import { render, staticRenderFns } from "./RenyuanAdd.vue?vue&type=template&id=3790c47a&scoped=true"
import script from "./RenyuanAdd.vue?vue&type=script&lang=js"
export * from "./RenyuanAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3790c47a",
  null
  
)

export default component.exports